import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1865.91247,880.774118 C1884.77365,938.712941 1898.10071,998.571765 1905.55482,1058.88235 C1910.29835,1098.52471 1912.78306,1138.05412 1912.78306,1178.71294 C1912.78306,1219.37176 1910.29835,1258.90118 1905.55482,1298.43059 C1884.54776,1468.52 1817.34776,1630.81647 1711.18306,1767.81412 L1711.18306,1767.81412 L1621.95953,1698.69412 C1715.70071,1577.73412 1774.99482,1434.52471 1793.51718,1284.76471 C1797.696,1249.75294 1799.84188,1214.74118 1799.84188,1178.71294 C1799.84188,1142.68471 1797.696,1107.67294 1793.40424,1072.54824 C1786.96659,1019.57882 1775.22071,966.835294 1758.50541,915.898824 L1758.50541,915.898824 Z M112.037647,1284.76471 C130.56,1434.52471 189.854118,1577.73412 283.595294,1698.69412 L283.595294,1698.69412 L194.371765,1767.81412 C88.2070588,1630.81647 21.0070588,1468.52 -5.68434189e-14,1298.54353 L-5.68434189e-14,1298.54353 Z M1816.33129,456.589647 L1896.18071,536.552 L1009.25365,1423.47906 L498.759529,912.984941 L578.608941,833.135529 L1009.25365,1263.78024 L1816.33129,456.589647 Z M194.371765,589.611765 L283.595294,658.731765 C189.854118,779.691765 130.56,922.901176 112.037647,1072.66118 L112.037647,1072.66118 L-5.68434189e-14,1058.88235 C21.0070588,888.905882 88.2070588,726.609412 194.371765,589.611765 L194.371765,589.611765 Z M1072.63624,225.952471 C1242.61271,246.846588 1404.90918,314.159529 1541.90682,420.324235 L1541.90682,420.324235 L1472.78682,509.547765 C1351.71388,415.806588 1208.61741,356.512471 1058.85741,337.990118 L1058.85741,337.990118 Z M832.941176,225.941176 L846.72,337.978824 C696.96,356.501176 553.750588,415.795294 432.790588,509.536471 L432.790588,509.536471 L363.670588,420.312941 C500.668235,314.148235 662.964706,246.948235 832.941176,225.941176 L832.941176,225.941176 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconSpeedGraderLine = /*#__PURE__*/function (_Component) {
  _inherits(IconSpeedGraderLine, _Component);

  var _super = _createSuper(IconSpeedGraderLine);

  function IconSpeedGraderLine() {
    _classCallCheck(this, IconSpeedGraderLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconSpeedGraderLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSpeedGrader",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconSpeedGraderLine.displayName = "IconSpeedGraderLine";
  return IconSpeedGraderLine;
}(Component);

IconSpeedGraderLine.glyphName = 'speed-grader';
IconSpeedGraderLine.variant = 'Line';
IconSpeedGraderLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSpeedGraderLine;
export { IconSpeedGraderLine };